module.exports = __webpack_public_path__ + "img/04-3-5总览.21d9a49c.png";